/**
 * Calm notice on `/demo` after a demo session ended (#2986).
 *
 * The auth gate sends a demo visitor here when their session ran out, with
 * the "ended" flag set (`lib/demoSession`). The notice reads the flag on the
 * first render, shows once in each tab, and leaves the redirect flag set.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  clearDemoEnded,
  markDemoEndedNoticeSeen,
  shouldShowDemoEndedNotice,
} from "../lib/demoSession";

export function DemoEndedNotice() {
  // Shows once in each tab. The redirect signal stays, so Back to a team
  // link still goes to `/demo` (#2998). The initializer only reads, so a
  // StrictMode double render still shows the notice.
  const [ended] = useState(shouldShowDemoEndedNotice);
  useEffect(() => {
    if (ended) markDemoEndedNoticeSeen();
  }, [ended]);
  if (!ended) return null;
  return (
    <output
      data-testid="demo-ended-notice"
      className="mx-auto mt-4 w-full max-w-2xl block rounded-lg border border-border bg-bg-subtle px-4 py-3 text-sm text-fg"
    >
      Your demo ended. Pick a team to start a new one.{" "}
      <Link to="/sign-in" onClick={clearDemoEnded} className="underline">
        Sign in instead
      </Link>
    </output>
  );
}
